import { ERMPortalUrls } from '../../constants/routing/urls.constants';
import { Roles } from '../../constants/security/roles.constants';

const isFeedbackEnabled = false;

export const GenerateUserAccountConfig = (logoutOverride, user) => {
    return {
        user: {
            userId: user?.id ?? null,
            username: user?.name ?? null,
            email: user?.email ?? null,
        },
        options: GenerateOptions(logoutOverride, user),
    };
};

const GenerateOptions = (logoutOverride, user) => {
    const options = [
        // Add the guaranteed defaults
        {
            icon: null,
            text: 'My Access',
            href: ERMPortalUrls.myAccess,
            target: '_blank',
        },
        {
            icon: null,
            text: 'Conduct Declarations',
            href: ERMPortalUrls.conductDeclarations,
            target: '_blank',
        },
    ];

    isFeedbackEnabled &&
        options.push({
            icon: null,
            text: 'Feedback',
            callback: () => {},
            hidden: true,
        });

    (user?.roles?.includes(Roles.Admin) || user?.roles?.includes(Roles.Developer)) &&
        options.push({
            icon: null,
            text: 'Admin',
            href: ERMPortalUrls.admin,
        });

    logoutOverride &&
        options.push({
            text: 'Logout',
            css: 'logout',
            callback: logoutOverride ?? (() => {}),
        });

    return options;
};
